export default __webpack_public_path__ + "static/media/megane-colour-2.9fb07772.jpg";